/*
 * VR / Meta Quest headset-browser helpers.
 *
 * The viewer is used both on a laptop (mouse) and inside the Meta Quest browser (controller as a
 * laser pointer). These helpers let the UI adapt ONLY for the headset — laptop behaviour is never
 * touched, because nothing here runs unless isVRBrowser() is true.
 */

export function isVRBrowser() {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return /OculusBrowser|Meta Quest|Quest/i.test(navigator.userAgent || '');
}

/*
 * Best-effort controller-button watch for the flat Quest browser. When the Meta Quest browser
 * exposes the controllers through the Gamepad API, this fires onFaceButton(index) on the rising
 * edge of a face button (A/B/X/Y → standard XR indices 4 & 5, so "Y" is covered). If the browser
 * does not expose the controllers outside an immersive session, this is simply a harmless no-op.
 *
 * Returns a stop() function.
 */
export function startGamepadWatch(onFaceButton) {
  if (typeof navigator === 'undefined' || !navigator.getGamepads || typeof window === 'undefined') {
    return () => {};
  }
  let raf = null;
  const prev = {};
  const FACE_BUTTONS = [4, 5];
  const poll = () => {
    const pads = navigator.getGamepads() || [];
    for (const pad of pads) {
      if (!pad) {
        continue;
      }
      const buttons = pad.buttons || [];
      for (const idx of FACE_BUTTONS) {
        const button = buttons[idx];
        const pressed = !!(button && button.pressed);
        const key = pad.index + ':' + idx;
        if (pressed && !prev[key]) {
          onFaceButton(idx);
        }
        prev[key] = pressed;
      }
    }
    raf = window.requestAnimationFrame(poll);
  };
  raf = window.requestAnimationFrame(poll);
  return () => {
    if (raf) {
      window.cancelAnimationFrame(raf);
    }
  };
}
